module.exports = __webpack_public_path__ + "static/blackjack-da6e9cf42e9300158680fc9143a1aeff.png";